<div class="header">
    <h2>{{ 'courses.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="courses-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'courses.error.unavailable' | translate" />
} @else if (course(); as course) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h1>{{ course.name }}</h1>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'courses.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'courses.form.description' | translate }}</span>
                @if (course.description) {
                    <span class="value pre">{{ course.description }}</span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
            <div class="field">
                <span class="label">{{ 'courses.form.type' | translate }}</span>
                <span class="value">{{ 'course.type.' + course.type | translate }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'courses.form.instructor' | translate }}</span>
                @if (course.instructorId) {
                    <span class="value" app-value-name [id]="course.instructorId" type="instructor"></span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
        </div>

        <!-- TODO: Objectives field - hidden until add/edit form UI is built. Do not remove. -->
        <!-- <div class="section">
            <h2>{{ 'courses.fieldset.content' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'courses.form.objectives' | translate }}</span>
                @if (course.objectives.length) {
                    <span class="value">{{ course.objectives.join(', ') }}</span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
        </div> -->

        <div class="section">
            <h2>{{ 'courses.form.modules' | translate }}</h2>
            <app-entity-list [ids]="course.moduleIds" type="module" emptyKey="courses.modules.empty" />
        </div>

        <div class="section">
            <h2>{{ 'courses.fieldset.materials' | translate }}</h2>
            <app-material-list-view [ids]="course.materialIds" emptyKey="courses.materials.empty" />
        </div>

        <div class="section">
            <h2>{{ 'courses.fieldset.images' | translate }}</h2>
            <div class="images">
                <div class="image-field">
                    <span class="label">{{ 'courses.form.placeholder' | translate }}</span>
                    @if (course.mediaPlaceholderId) {
                        <app-media-image class="thumbnail landscape" [mediaId]="course.mediaPlaceholderId" />
                    } @else {
                        <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                    }
                </div>
                <div class="image-field">
                    <span class="label">{{ 'courses.form.placeholderPortrait' | translate }}</span>
                    @if (course.mediaPlaceholderPortraitId) {
                        <app-media-image class="thumbnail portrait" [mediaId]="course.mediaPlaceholderPortraitId" />
                    } @else {
                        <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                    }
                </div>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'courses.fieldset.assessment' | translate }}</h2>
            @if (assessmentFacade.assessment(); as assessment) {
                <div class="field">
                    <span class="label">{{ 'courses.form.name' | translate }}</span>
                    <span class="value">{{ assessment.name }}</span>
                </div>
                <div class="field">
                    <span class="label">{{ 'courses.form.description' | translate }}</span>
                    @if (assessment.description) {
                        <span class="value pre">{{ assessment.description }}</span>
                    } @else {
                        <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                    }
                </div>
                <div class="field">
                    <span class="label">{{ 'courses.form.showToAssessor' | translate }}</span>
                    <span class="value">{{ (assessment.showToAssessor ? 'common.yes' : 'common.no') | translate }}</span>
                </div>
            } @else {
                <p class="empty">{{ 'courses.assessment.empty' | translate }}</p>
            }
        </div>

        @if (course.tagIds.length) {
            <div class="section">
                <h2>{{ 'courses.form.tags' | translate }}</h2>
                <span class="value">{{ course.tagIds.join(', ') }}</span>
            </div>
        }
    </div>

    <div class="footer">
        <app-delete-button [courseId]="course.id" [saving]="saving()" testId="courses-view-delete" />
        <p-button [label]="'courses.detail.edit' | translate" icon="pi pi-pencil" data-test="courses-view-edit" (onClick)="onEdit()" />
    </div>
}
